let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aHCaB")).then(() => parcelRequire('3omFm'));